import React from "react"
import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"

const OnBoardingContent = ({ classes, image, heading, content }) => {
  return (
    <div className={classes.contentContainer}>
      <div className={classes.imageContainer}>
        <img src={image} />
      </div>
      <div className={classes.textContainer}>
        <Typography className={classes.heading} variant="h3">
          {heading}
        </Typography>
        <Typography className={classes.content}>{content}</Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(OnBoardingContent)



// WEBPACK FOOTER //
// ./src/pages/OnBoarding/components/OnBoardingContent/index.js